import React from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import Web3 from "web3";
import { Web3ReactProvider } from "@web3-react/core";

import { FiltersProvider } from "./services/context/filters";
import { W3Provider } from "./services/context";

import App from "./App";

import "./index.css";

const { REACT_APP_ENV, REACT_APP_GTM_ID } = process.env;

if (REACT_APP_ENV === "production") {
  TagManager.initialize({
    gtmId: REACT_APP_GTM_ID,
  });
}

function getLibrary(provider) {
  return new Web3(provider);
}

function Main() {
  return (
    <W3Provider>
      <FiltersProvider>
        <App />
      </FiltersProvider>
    </W3Provider>
  );
}

ReactDOM.render(
  <Web3ReactProvider getLibrary={getLibrary}>
    <Main />
  </Web3ReactProvider>,
  document.getElementById("root")
);
